export default __webpack_public_path__ + "static/media/twist.12b671fb.svg";